import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export default function Footer() {
    return (
        <Container className="mt-5 py-3">
            <Row>
                <Col sm={12} md={3} className="text-center my-sm-2">
                    <p className="mb-1">Gartenbau Henkel GmbH</p>
                    <p className="mb-1">Alte Bayernwerkstraße 277</p>
                    <p className="mb-1">85757 Karlsfeld</p>
                </Col>
                <Col sm={12} md={3} className="text-center my-sm-2">
                    <p className="mb-1"><a href="tel:+49-171-2845843">+49 (0) 171 2845843</a></p>
                    <p className="mb-1"><a href="tel:+49-8131-6150030">+49 (0) 8131 6150030</a></p>
                    <p className="mb-1"><a href="mailto:mail@gartenbau-henkel.de">mail@gartenbau-henkel.de</a></p>
                </Col>
                <Col sm={12} md={3} className="text-center">
                    <Link to="/imprint">
                        <p className="mb-1">Impressum</p>
                    </Link>
                    <Link to="/privacy">
                        <p className="mb-1">Datenschutz</p>
                    </Link>
                </Col>
                <Col sm={12} md={3} className="text-center">
                    <img
                        onClick={() => {
                            window.scrollTo(0, 0)
                        }}
                        src={require('../media/iconlogo_black.png')}
                        className="two-lines-high cursor-pointer"
                    />
                </Col>
            </Row>
        </Container>
    )
}
